import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PsFile} from '../../user/components/public-services/ps-file';

@Injectable()
export class FileService {

  constructor(private _http: HttpClient) {
  }

  getFile(fileId) {
    return this._http.get(`api/file/get/${fileId}`, {responseType: 'blob'});
  }

  getEgovFile(fileId) {
    return this._http.get(`api/file/egov/get/${fileId}`, {responseType: 'blob'});
  }

  getFileById(fileId) {
    return this._http.get(`api/file/get/${fileId}`, {responseType: 'blob', observe: 'response'});
  }

  downloadFileHeaders(resp) {
    const contentType = resp.headers.get('Content-Type').split(';')[0];
    const contentDisposition = resp.headers.get('Content-Disposition');
    const fileName = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
    const blob = new Blob([resp.body], {type: contentType});
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = decodeURIComponent(fileName);
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
  }

  getFileInfo(fileId) {
    return this._http.get<any>(`api/file/get/info/${fileId}`);
  }

  downloadFile(data, fileName, contentType) {
    const blob = new Blob([data], {type: contentType});
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  }

  download2003ExcelFile(data, fileName) {
    const contentType = 'application/x-msexcel';
    this.downloadFile(data, fileName, contentType);
  }

  download2007ExcelFile(data, fileName) {
    const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    this.downloadFile(data, fileName, contentType);
  }

  showPdfFile(data, fileName, contentType) {
    const res = new Blob([data], {type: contentType});
    const fileURL = URL.createObjectURL(res);
    window.open(fileURL);
  }

  downloadPsFile(data, file: PsFile) {
    this.downloadFile(data, file.name, file.contentType);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/services/file.service.ts